import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class TopbarMenuButton extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  render() {
    const { title, icon, onClick } = this.props;

    return (
      <button className="topbar__link" type="submit" onClick={onClick}>
        <span className={`topbar__link-icon lnr lnr-${icon}`} />
        <p className="topbar__link-title">{title}</p>
      </button>
    );
  }
}
